module.exports = __webpack_public_path__ + "2d1c965b9f28eca0d3286fa43d1a5f95.woff";